import React, { useState, useEffect, useContext , useRef } from "react";
import { useNavigate } from "react-router-dom";
import { WebAssetsContext } from "../App";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import Addwallet from '../components/admin/Addwallet';
import Userspagination from './Userspagination';
import PaginationCustom from '../components/admin/PaginationCustom';
import  { filebasepath }  from "../functions/Function";
const Users = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const HandleClickOnEditUser = (id = '') => {
    navigate("/admin/users/edit/" + id);
  }
  const searchtext = useRef('');
  const currentpage = useRef(1);
  const per_page = useRef(10);
  const [totalRecords, settotalRecords] = useState(0);
  const [totalPages, settotalPages] = useState(0);
  const [data, setdata] = useState([]);
  const [users, setUsers] = useState([]);
  const fetchData = () => {
  fetch(api + "userwithpagination?pagesize="+per_page.current+"&currentpage="+currentpage.current+"&search="+searchtext.current)
      .then(res => res.json())
      .then((result) => {
        if (result.status == true) {
          console.log('test' + result.response);
          console.log(result.response);
          updateData(result);
          settotalRecords(result.response.total_records);
          settotalPages(result.response.total_pages);
          setUsers(result.response.users);
        }
      }
      )
  }

  const HandleClickOnDeleteUser = async (id = '') => {
    Swal.fire({
      title: 'Are you sure you want to delete it ?',
      text: "Once deleted, you will not be able to get it again!",
      icon: 'warning',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const resJson = DeleteUser(id);
          resJson.then(function (output) {
            if (output.status == true) {
              Swal.fire({
                title: 'Deleted!',
                text: "User has been deleted successfully.",
                icon: 'success'
              }).then((finalresult) => {
                if (finalresult.isConfirmed) {
                  fetchData();
                }
              });
            }
          });

        } catch (err) {
          console.log(err);
        }

      }
    });


  }
  const DeleteUser = async (id = '') => {
    const res = await fetch(api + "deleteUser", {
      method: "POST",
      body: JSON.stringify({ id: id }),
    });
    let resJson = await res.json();
    return resJson;
  }


  const [show, setShow] = useState(false);
  const [user, setUser] = useState(null);
  const HandleClickonAddWallet = (user) => {
    setShow(true)
    setUser(user)
  }

  const hideModal = () => {
    setShow(false);
  }

  const updateData = (getdata='') =>
  {
      setdata(getdata.response.users);
  }
  const updateCurrentPage = (current_page=1) =>
  {
      currentpage.current = current_page;
      fetchData();
  }
const filterBySearch = (event) => {
     const query = event.target.value;
     currentpage.current = 1;
     searchtext.current = query.toLowerCase();
     fetchData();
  };

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <>
      <Addwallet show={show} hideModal={hideModal} user={user} fetchData={fetchData} />
     
      <div className="section-body">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="pt-4 pl-4 pr-4">
                        <div className="card-header pl-0 pr-0 w-50 float-left">
                          <h4 className="headercolor">Customer List</h4>
                        </div>
                        <div className="float-right">
                          <button onClick={() => navigate("/admin/users/add")} className="btn btn-icon icon-left btn-primary"><i className="fas fa-plus"></i> Add Customer</button>
                        </div>
                      </div>
                      <div className="card-body pl-4 pr-4 pb-4 pt-0">
                        <div>
                          {/* <select>
                              <option value={10}>10</option>
                              <option value={20}>20</option>
                              <option value={100}>100</option>
                          </select> */}
                        <input  onChange={filterBySearch} className="search-input" placeholder="Search..." /> 
                        </div>
                         
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">S.NO</th>
                                <th>Profile</th>
                                <th>Name</th>
                                <th width={'180px'} >Email</th>
                                <th>Email Verified</th>
                                <th>KYC</th>
                                <th>Status</th>
                               
                                <th className="text-right" width={'250px'}>
                                    <span className="actionw-250">Action</span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>

                              {users.length > 0 ? users.map((user, i) => (

                                <tr key={i}>
                                  <td className="text-center">{i + 1}</td>

                                  <td>
                                    {user.profile ?
                                      <img id={'user_' + user.id} alt="image" src={filebasepath()+user.profile} className="rounded-circle avatarborder cusror" 
                                      width="35" height="35"  data-tooltip-content={user.phone + ' | ' + user.name}  onClick={() => navigate("/admin/users/view/" + user.id)} />
                                      :
                                      <img id={'user_' + user.id} alt="image" src={WebAssets.tableuserDefaultImg} className="rounded-circle avatarborder cusror " height="35"  width="35" data-tooltip-content={ user.phone + ' | ' + user.name}  onClick={() => navigate("/admin/users/view/" + user.id)} />}

                                    <Tooltip anchorId={'user_' + user.id} />

                                  </td>
                                  <td><span className="cusror cname" onClick={() => navigate("/admin/users/view/" + user.id)}>{user.name.split(" ")[0]}</span></td>

                                  <td>{user.email}</td>
                                  <td>
                                        {user.is_email_verify == '1' ? <div className="badge badge-success">Verified</div> : <div className="badge badge-danger badge-sm">Unverified</div>}
                                  </td>
                                  <td>
                                        {user.is_email_verify == '1' ? <div className="badge badge-success">Verified</div> : <div className="badge badge-danger badge-sm">Unverified</div>}
                                  </td>
                                  <td>
                                    {user.status == '1' ? <div className="badge badge-success">Active</div> : <div className="badge badge-danger">In-Active</div>}

                                  </td>
                                  <td className="text-right">

                                    <button role="button"
                                      id={'view_' + user.id} onClick={() => navigate("/admin/users/view/" + user.id)}
                                      className="btn btn-icon btn-primary mr-2" data-tooltip-content="View Details">
                                      <i className="fas fa-eye"></i>
                                    </button>
                                    <Tooltip anchorId={'view_' + user.id} />


                                    <button role="button"
                                      id={'addWallet_' + user.id} onClick={() => HandleClickonAddWallet(user)}
                                      className="btn btn-icon btn-primary mr-2" data-tooltip-content="Add Wallet">
                                      <i className="fas fa-wallet"></i>
                                    </button>
                                    <Tooltip anchorId={'addWallet_' + user.id} />


                                    <button role="button"
                                      id={'edit_' + user.id} onClick={() => HandleClickOnEditUser(user.id)}
                                      className="btn btn-icon btn-primary mr-2" data-tooltip-content="Edit">
                                      <i className="far fa-edit"></i>
                                    </button>
                                    <Tooltip anchorId={'edit_' + user.id} />

                                    <button role="button" id={'delete_' + user.id} onClick={() => HandleClickOnDeleteUser(user.id)} className="btn btn-icon btn-danger" data-tooltip-content="Delete" ><i className="far fa-trash-alt"></i></button>
                                    <Tooltip anchorId={'delete_' + user.id} />
                                  </td>
                                </tr>
                              )) :

                                <tr><td colSpan="10" className="text-center">Data not yet found. </td></tr>
                              }



                            </tbody>
                          </table>
                        </div>
                        <PaginationCustom 
                              data={data}
                              totalRecords={totalRecords}
                              totalPages={totalPages}
                              updateCurrentPage={updateCurrentPage}
                            
                              currentpage={currentpage.current}
                            />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
     
    </>

  );
}

export default Users;
